import { Controller } from "@hotwired/stimulus"

// Mirrors a euro amount into its koruna counterpart at a fixed rate, the way
// the variant form does for its price grid. Inputs pair up by the `field`
// param: typing into the euro "price" fills the koruna "price", the euro
// "freight_surcharge" fills the koruna "freight_surcharge".
//
// Connects to data-controller="exchange-rate"
export default class extends Controller {
  static targets = ["source", "destination"]
  static values = { rate: Number }

  convert({ target, params: { field } }) {
    const amount = target.value === "" ? "" : Math.round(Number(target.value) * this.rateValue)

    this.destinationTargets
      .filter((destination) => destination.dataset.exchangeRateFieldParam === field)
      .forEach((destination) => {
        destination.value = amount
        // Let the "= 5,000 Kč" preview next to the field catch up.
        destination.dispatchEvent(new Event("input", { bubbles: true }))
      })
  }
}
